import { createReducer } from 'redux-create-reducer';
// import {
//   USER_EXPIRED, USER_EXPIRING, REDIRECT_SUCCESS, LOADING_USER,
// } from 'redux-oidc';
// import { userManagerFactory } from '../utils/userManager';

const initialState = {
  isExpired: false,
  isExpiring: false,
  userLogged: false,
};

const userReducer = createReducer(initialState, {
  // [USER_EXPIRING]: (state, { payload }) => ({
  //   ...state,
  //   isExpiring: true,
  // }),
  // [USER_EXPIRED]: (state, { payload }) => {
  //   const authorityUrl = localStorage.getItem('authorityUrl');
  //   const accessToken = localStorage.getItem('accessToken');
  //   const expiresAt = localStorage.getItem('expiresAt');
  //   if ((state.isExpiring && authorityUrl) || (!state.isExpiring && authorityUrl && accessToken && expiresAt)) {
  //     const userManager = userManagerFactory();
  //     userManager.getUser().then((rez) => {
  //       userManager.signoutRedirect({ id_token_hint: rez.id_token }).then(() => {
  //         userManager.removeUser();
  //         localStorage.removeItem('remaining');
  //         localStorage.removeItem('expiresAt');
  //         localStorage.removeItem('accessToken');
  //         localStorage.removeItem('authorityUrl');
  //         localStorage.removeItem('orgName');
  //       });
  //     });
  //   }
  //   else if (!state.isExpiring) {
  //     localStorage.removeItem('remaining');
  //     localStorage.removeItem('expiresAt');
  //     localStorage.removeItem('accessToken');
  //   }
  //   return ({
  //     ...state,
  //     isExpired: true,
  //   });
  // },
  // [LOAD_USER_ERROR]: (state, { payload }) => {
  //   debugger;
  // },
  // [USER_SIGNED_OUT]: (state, { payload }) => {
  //   debugger;
  // },
});

export default userReducer;



// WEBPACK FOOTER //
// ./src/services/oidc/reducer/userReducer.js